import { SVGProps } from 'react';
import { useTranslation } from 'next-i18next';
import { ChevronRightIcon } from '../../../icons';
export const PlanStepBreadCrumbs = () => {
  const {
    t
  } = useTranslation(['subscription']);
  return <div className="flex w-full items-center justify-end gap-xs" data-sentry-component="PlanStepBreadCrumbs" data-sentry-source-file="PlanStepBreadCrumbs.tsx">
      <div className="flex items-center gap-2xs">
        <PrimaryCircle1Svg data-sentry-element="PrimaryCircle1Svg" data-sentry-source-file="PlanStepBreadCrumbs.tsx" />
        <span className="text-body-2-b font-bold text-primary">
          {t('subscription:payment.planSelect.subTitle', '플랜 선택')}
        </span>
      </div>
      <span>
        <ChevronRightIcon width={14} height={14} className="text-gray-400" data-sentry-element="ChevronRightIcon" data-sentry-source-file="PlanStepBreadCrumbs.tsx" />
      </span>
      <div className="flex items-center gap-2xs">
        <SubCircle2Svg data-sentry-element="SubCircle2Svg" data-sentry-source-file="PlanStepBreadCrumbs.tsx" />
        <span className="text-body-2-b font-bold text-gray-400">
          {t('subscription:payment.breadCrumbs.planComplete', '결제 완료')}
        </span>
      </div>
    </div>;
};
const PrimaryCircle1Svg = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={17} height={16} fill="none" {...props} data-sentry-element="svg" data-sentry-component="PrimaryCircle1Svg" data-sentry-source-file="PlanStepBreadCrumbs.tsx">
    <rect width={16} height={16} x={0.5} fill="#6758FF" rx={8} data-sentry-element="rect" data-sentry-source-file="PlanStepBreadCrumbs.tsx" />
    <path fill="#fff" d="M9.778 3.723V11.5H8.371V5.087h-.043l-1.815 1.16V4.97l1.923-1.246h1.342Z" data-sentry-element="path" data-sentry-source-file="PlanStepBreadCrumbs.tsx" />
  </svg>;
const SubCircle2Svg = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props} data-sentry-element="svg" data-sentry-component="SubCircle2Svg" data-sentry-source-file="PlanStepBreadCrumbs.tsx">
    <rect width={16} height={16} fill="#BEC3CC" rx={8} data-sentry-element="rect" data-sentry-source-file="PlanStepBreadCrumbs.tsx" />
    <path fill="#fff" d="M5.33 11.5v-1.01l2.75-2.653c.785-.784 1.193-1.246 1.193-1.901 0-.726-.575-1.182-1.332-1.182-.8 0-1.316.5-1.31 1.289H5.297C5.293 4.571 6.4 3.615 7.952 3.615c1.59 0 2.659.95 2.664 2.256-.005.876-.425 1.585-1.955 3.03l-1.386 1.374v.054h3.459V11.5H5.331Z" data-sentry-element="path" data-sentry-source-file="PlanStepBreadCrumbs.tsx" />
  </svg>;